import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { getCompetitionById } from "../services/competitionsServices";

const Breadcrumb = ({ competitionName }) => {
  const location = useLocation();
  const params = useParams();
  const [computedName, setComputedName] = useState("");

  useEffect(() => {
    if (!competitionName && params.competition_id) {
      const fetchCompetition = async () => {
        try {
          const competition = await getCompetitionById(params.competition_id);
          setComputedName(competition.nom_competition);
        } catch (error) {
          console.error(
            "Erreur lors de la récupération du nom de la compétition:",
            error
          );
        }
      };
      fetchCompetition();
    } else {
      setComputedName(competitionName);
    }
  }, [competitionName, params.competition_id]);

  const pathnames = location.pathname.split("/").filter((x) => x);

  const routeNameMap = {
    competitions: "Mes Compétitions",
    repartition: "Répartition des Judokas",
    resultats: "Résultats",
    judokas: "Pesées",
    tapis: "Tapis",
  };

  return (
    <nav
      className="text-gray-700 dark:text-white text-sm mb-6"
      aria-label="breadcrumb"
    >
      <ol className="flex flex-wrap gap-x-2 gap-y-1 items-center text-sm sm:text-base">
        <li>
          <Link to="/" className="hover:underline text-primary uppercase">
            Accueil
          </Link>
        </li>
        {pathnames.map((value, index) => {
          const isLast = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          let displayName = routeNameMap[value] || value;

          // ✅ Cas particulier pour `/competition/:id`
          if (pathnames[0] === "competition" && index === 1 && !isNaN(value)) {
            displayName = computedName || `Compétition ${value}`;
          }

          return (
            <li key={to} className="flex items-center uppercase">
              <span className="mx-2">/</span>
              {isLast ? (
                <span className="font-semibold">{displayName}</span>
              ) : (
                <Link to={to} className="hover:underline text-primary">
                  {displayName}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
